import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { EditFormContent, DatePickerField, BaasicButton, BaasicFormControls } from 'core/components';
function FacilityOrderNewFlowInventoryCountEditModalTemplate({ facilityOrderNewFlowInventoryCountEditModalStore, t }) {
	const {
		id,
		form,
		modalParams,
		refreshInventoryCalculation
	} = facilityOrderNewFlowInventoryCountEditModalStore;
	return (
		<EditFormContent form={form}>
			<div className="modal__header">
				<h3 className='modal__header__title'>{t(id ? 'FACILITY_ORDER_NEW_FLOW_INVENTORY.INVENTORY_COUNT_MODAL.EDIT_COUNT_DATE' : 'FACILITY_ORDER_NEW_FLOW_INVENTORY.INVENTORY_COUNT_MODAL.START_FACILITY_INVENTORY')}</h3>
			</div>
			<div className="modal__body u-mar--b--tny">
				<div className="form__group">
					<DatePickerField field={form.$('countDate')} />
				</div>
			</div>
			<div className='u-separator--primary'></div>
			<div className='modal__footer'>
				<BaasicButton
					className='btn btn--med btn--light'
					label={t('EDIT_FORM_LAYOUT.CANCEL')}
					disabled={form.submitting}
					onClick={() => modalParams.close()}
				/>
				<BaasicFormControls
					className='btn btn--primary btn--med'
					form={form}
					onSubmit={form.onSubmit}
					disabled={form.submitting || form.validating}
					label={refreshInventoryCalculation ? "Save and Refresh Calculation" : t(id ? 'EDIT_FORM_LAYOUT.SAVE' : 'EDIT_FORM_LAYOUT.START')}
				/>
			</div>
		</EditFormContent>
	)
}

FacilityOrderNewFlowInventoryCountEditModalTemplate.propTypes = {
	facilityOrderNewFlowInventoryCountEditModalStore: PropTypes.object,
	t: PropTypes.func
};

export default defaultTemplate(FacilityOrderNewFlowInventoryCountEditModalTemplate);
